import { i18n } from '../custom/translator.js';
import globalStylesUrl from 'url:../styles/global.css';
import headerLogoUrl from 'url:../images/logo.svg';
import phUser from 'url:../images/svg/ph-user.svg';
class CustomHeader extends HTMLElement {
  constructor() {
    super();
    // Crucial: Must be set to 'open' so our scanner can access it
    this.attachShadow({ mode: 'open' });
    //this.shadowRoot.adoptedStyleSheets = [globalStyles];
    // 1. Initialize private backing fields with default fallback URLs
    this._androidUrl =
      'https://play.google.com/store/apps/details?id=app.myandroidhello.com.chatmurcianys&pcampaignid=web_share';
    this._iosUrl = 'https://apps.apple.com/in/app/chatmurcianys/id6480422290';
    this._desktopUrl = 'https://p1mm.org';
    //this._zeffyLink = '';
    this._zeffyCampaign = 'donate-to-change-lives-6222';
  }

  // 1. Tell the component which attributes to watch
  static get observedAttributes() {
    return ['android-url', 'ios-url', 'desktop-url', 'zeffy-campaign'];
  }

  // 2. Automatically re-run the logic if an attribute changes
  attributeChangedCallback(name, oldValue, newValue) {
    // if (oldValue !== newValue && name === 'zeffy-link') {
    //   this._zeffyLink = newValue;
    // }
    if (oldValue !== newValue && name === 'zeffy-campaign') {
      this._zeffyCampaign = newValue;
      this.updateCampaignBtn(this._zeffyCampaign);
      return;
    }
    if (oldValue !== newValue && this.shadowRoot.innerHTML) {
      this.setupDownloadButton();
    }
  }

  updateCampaignBtn(zeffyCampaign) {
    const btnDonate = this.shadowRoot.querySelector('.btn-donate-nav');
    console.log('Updating campaign button with zeffyCampaign:', zeffyCampaign);
    if (btnDonate) {
      btnDonate.setAttribute(
        'data-i18n-data',
        `{"campaign":"${zeffyCampaign}"}`,
      );
      i18n.translatePage(btnDonate);
    }
  }
  // get activeZeffyLink() {
  //   const attrValue = this.getAttribute('zeffy-link');
  //   // If the attribute is missing or empty, output our explicit i18n flag
  //   return attrValue !== null && attrValue.trim() !== ''
  //     ? attrValue.trim()
  //     : 'from-i18n';
  // }

  get activeZeffyCampaign() {
    const attrValue = this.getAttribute('zeffy-campaign');
    // If the attribute is missing or empty, output our explicit i18n flag
    return attrValue !== null && attrValue.trim() !== ''
      ? attrValue.trim()
      : this._zeffyCampaign;
  }
  render() {
    // const zeffyLink = this.activeZeffyLink;
    const zeffyCampaign = this.activeZeffyCampaign;
    this.shadowRoot.innerHTML = `
    <link rel="stylesheet" href="${globalStylesUrl}">
    <!-- Header Navigation -->
    <header class="navbar">
      <div class="logo">
        <a href="index.html">
          <img
            src="${headerLogoUrl}"
            alt="P1MM Logo"
            width="48px"
            data-i18n-attr='{"alt":"p1mm_logo"}'
          />
          <span data-i18n="head_p1mm">Por Un Mundo Mejor</span>
        </a>
      </div>
      <div class="nav-main-drop">
        <button
          class="nav-toggle"
          aria-label="Toggle navigation"
          data-i18n-attr='{"aria-label":"toggle_nav"}'
        >
          <span class="hamburger"></span>
        </button>

        <nav class="nav-links h-flex">
          <a href="index.html" data-i18n="nav_home">Home</a>
          <div class="nav-dropdown">
            <a href="#" class="dropdown-trigger"
              ><span data-i18n="nav_about">About Us</span>
              <span class="arrow">▼</span></a
            >
            <div class="submenu">
              <a href="about.html" data-i18n="nav_mission">Our Mission</a>
              <!-- <a href="team.html">Meet the Team</a> -->
              <!-- <a href="work.html">Our Work</a> -->
              <a href="projects.html" data-i18n="nav_current_projects"
                >Current Projects</a
              >
              <!-- <a href="credentials.html">Credentials</a> -->
            </div>
          </div>
          <a href="projects.html" data-i18n="nav_projects">Projects</a>
          <a href="join.html" data-i18n="nav_join_us">Join Us</a>
        </nav>
      </div>

      <div class="nav-actions">
        <button
          data-i18n="donate"
          class="btn-donate-nav"
          data-i18n-data='{"campaign":"${zeffyCampaign}"}'
          data-i18n-attr='{"zeffy-form-link":"zeffy_popup"}'
          zeffy-form-link="https://zeffy.com"
        >
          Donate
        </button>
        <select class="lang-select" id="selLang">
          <option value="en" selected title="en">English</option>
          <option value="es" title="es">Español</option>
        </select>

        <!-- User Login / Profile Picture Option -->
        <div class="user-profile-menu display-none" id="mnUserProfile">
          <!-- If logged out: <button class="btn-login">Volunteer Login</button> -->
          <!-- If logged in (Current View): -->
          <img
            src="${phUser}"
            alt="User Profile"
            class="profile-avatar"
            data-i18n-attr='{"alt":"nav_user_profile"}'
          />
          <span class="profile-name"
            ><span id="pfName">Oscar R.</span> <span>▼</span></span
          >
        </div>
      </div>
    </header>
    `;
  }

  connectedCallback() {
    this.render();
    //this.initZeffy();
    const switcher = this.shadowRoot.getElementById('selLang');
    i18n.initFromElement(switcher);
    //this.initDownloadButton();

    this.initMobileNav();
  }
  initMobileNav() {
    // const burgerBtn = this.shadowRoot.getElementById('burgerBtn');
    // const mobileNav = this.shadowRoot.getElementById('mobileNav');

    // burgerBtn.addEventListener('click', () => {
    //   burgerBtn.classList.toggle('open');
    //   mobileNav.classList.toggle('open');
    // });
    const navToggle = this.shadowRoot.querySelector('.nav-toggle');
    const navLinks = this.shadowRoot.querySelector('.nav-links');

    if (navToggle && navLinks) {
      navToggle.addEventListener('click', () => {
        // Toggle the animation utility classes on both elements
        navToggle.classList.toggle('is-active');
        navLinks.classList.toggle('is-active');
      });

      // Close the menu automatically if a user clicks an internal link
      navLinks.querySelectorAll('a:not(.dropdown-trigger)').forEach((link) => {
        link.addEventListener('click', () => {
          navToggle.classList.remove('is-active');
          navLinks.classList.remove('is-active');
        });
      });
    }
    // 2. NEW: Submenu Toggle for Mobile Touchscreens
    const dropdownTrigger = this.shadowRoot.querySelector('.dropdown-trigger');
    const navDropdown = this.shadowRoot.querySelector('.nav-dropdown');
    if (dropdownTrigger && navDropdown) {
      dropdownTrigger.addEventListener('click', (e) => {
        // Only run this logic on mobile screens
        if (window.innerWidth <= 1000) {
          e.preventDefault(); // Stop the browser from instantly following the '#' link
          navDropdown.classList.toggle('is-open'); // Toggles open/closed states cleanly
        }
      });
    }
  }
  initDownloadButton() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const downloadBtn = this.shadowRoot.getElementById('downloadNavTrigger');
    // Modal DOM References
    const downloadModal = this.shadowRoot.getElementById('downloadModal');
    const closeModalBtn = this.shadowRoot.getElementById('closeModalBtn');
    const downloadNavTrigger =
      this.shadowRoot.getElementById('downloadNavTrigger');

    if (!downloadBtn) return;

    // 3. Evaluate device type and apply the property values
    if (/android/i.test(userAgent)) {
      downloadBtn.href = this._androidUrl;
      downloadBtn.textContent = 'Google Play';
    } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
      downloadBtn.href = this._iosUrl;
      downloadBtn.textContent = 'App Store';
    } else {
      downloadBtn.href = this._desktopUrl;
      downloadBtn.textContent = 'Desktop App';

      // Helper functions to open and close
      const openModal = (e) => {
        e.preventDefault();
        downloadModal.classList.add('modal-open');
        downloadModal.setAttribute('aria-hidden', 'false');
      };

      const closeModal = () => {
        downloadModal.classList.remove('modal-open');
        downloadModal.setAttribute('aria-hidden', 'true');
      };

      // Event Trigger Listeners
      if (downloadNavTrigger) {
        downloadNavTrigger.addEventListener('click', openModal);
      }

      closeModalBtn.addEventListener('click', closeModal);

      // Close modal instantly if the user clicks out in the blurred layout mask area
      downloadModal.addEventListener('click', (e) => {
        if (e.target === downloadModal) {
          closeModal();
        }
      });

      // Accessibility: Allow hitting the Escape key to exit out of the modal frame
      document.addEventListener('keydown', (e) => {
        if (
          e.key === 'Escape' &&
          downloadModal.classList.contains('modal-open')
        ) {
          closeModal();
        }
      });
    }
  }
}

// Register the custom elements
customElements.define('custom-header', CustomHeader);
